import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import { CenterMediumContent, ContainedButton, Form, FormActions, MediumText, SmallText, Spinner, TextBox } from '@guryou/html-components';
import { cognitoResendSignUp, RESEND_SIGN_UP, resetState, stateIsLoaded, StateStatus } from '@guryou/redux';
import './main.css';

const ResendSignUp = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const resendSignUp = useSelector(state => state.cognito.resendSignUp);

  if (resendSignUp.status === StateStatus.LOADING) {
    return <Spinner big={true} />;
  }

  const handleSubmit = async ({ email }) => {
    dispatch(cognitoResendSignUp(email));
  };

  const handleGoToLogin = e => {
    e.preventDefault();
    dispatch(resetState(RESEND_SIGN_UP));
    history.push('/login');
  };

  return (
    <CenterMediumContent isPublicContent={false}>
      <div className="logoBg"></div>
      <Form className="login" onSubmit={handleSubmit} actions={false}>
        {stateIsLoaded(resendSignUp) ? (
          <MediumText textAlign="center">{t('CONFIRMATIONS.checkYourEmailForFurtherInstructions')}</MediumText>
        ) : (
          <>
            <h5 className="text-center">{t('GENERAL.resendActivationLink')}</h5>
            <TextBox name="email" label={t('GENERAL.email')} autoComplete="username" required />
          </>
        )}
        <FormActions>
          {!stateIsLoaded(resendSignUp) && (
            <ContainedButton style={{ backgroundColor: '#e6616a', color: 'white' }} type="submit" text={t('GENERAL.sendEmail')} />
          )}
          <br />
          <ContainedButton text={`${t('GENERAL.backToLogin')}`} onClick={handleGoToLogin} />
        </FormActions>
        <SmallText padding={2} color="red">
          {resendSignUp.error && resendSignUp.error.message}
        </SmallText>
      </Form>
    </CenterMediumContent>
  );
};

export default withRouter(ResendSignUp);
